import { useState, useCallback } from 'react';
import Toast from './Toast';
import './Toast.css';

let toastIdCounter = 0;

// Global toast manager
export const toastManager = {
    listeners: [],
    
    subscribe(listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    },
    
    notify(toast) {
        this.listeners.forEach(listener => listener(toast));
    },
    
    success(title, message, duration = 5000) {
        this.notify({ title, message, type: 'success', duration });
    },
    
    error(title, message, duration = 5000) {
        this.notify({ title, message, type: 'error', duration });
    },
    
    warning(title, message, duration = 5000) {
        this.notify({ title, message, type: 'warning', duration });
    },
    
    info(title, message, duration = 5000) {
        this.notify({ title, message, type: 'info', duration });
    }
};

function ToastContainer() {
    const [toasts, setToasts] = useState([]);
    
    const addToast = useCallback((toast) => {
        const id = `toast_${Date.now()}_${toastIdCounter++}`;
        setToasts(prev => [...prev, { ...toast, id }]);
    }, []);
    
    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    }, []);
    
    // Subscribe to toast manager
    useState(() => {
        const unsubscribe = toastManager.subscribe(addToast);
        return unsubscribe;
    });
    
    return (
        <div className="toast-container">
            {toasts.map(toast => (
                <Toast
                    key={toast.id}
                    id={toast.id}
                    title={toast.title}
                    message={toast.message}
                    type={toast.type}
                    duration={toast.duration}
                    onClose={removeToast}
                />
            ))}
        </div>
    );
}

export default ToastContainer;

